import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export class LoanService {
  constructor(private http: Http) {}

  private baseurl = environment.apiBaseUrl;

  // save an entry into loan table when click on add loan button
  saveLoan(data) {
    return this.http.post(`${this.baseurl}/loan/save`, { data }).map((res: Response) => res.json());
  }

  // when calculate button of first part of loan is clicked, then it executes
  saveLoanData(loanData) {
    return this.http
      .post(`${this.baseurl}/loan/saveLoanData`, { loanData })
      .map((res: Response) => res.json());
  }

  // update investment name and title onchange event
  updateLoan(loanId, data) {
    return this.http
      .post(`${this.baseurl}/loan/update`, { loanId, data })
      .map((response: Response) => response.json());
  }

  // get all loans from DB
  getLoans(projectId) {
    return this.http
      .post(`${this.baseurl}/loan/getLoans`, { projectId })
      .map((res: Response) => res.json());
  }

  // get loans with unique names, need in printing module only
  getUniqueLoans(projectId) {
    return this.http
      .post(`${this.baseurl}/loan/getUniqueLoans`, { projectId })
      .map((res: Response) => res.json());
  }

  // get loan Id's of all loans, related in printing module only
  getLoanIds(projectId, investorsNameArray) {
    return this.http
      .post(`${this.baseurl}/loan/getLoanIds`, { projectId, investorsNameArray })
      .map((res: Response) => res.json());
  }

  // not used now
  getLoansInvestor(projectId) {
    return this.http
      .post(`${this.baseurl}/loan/getLoansInvestor`, { projectId })
      .map((res: Response) => res.json());
  }

  // get single loan from DB
  getLoan(loanId) {
    return this.http
      .post(`${this.baseurl}/loan/getLoan`, { loanId })
      .map((res: Response) => res.json());
  }

  // soft delete entry of loan from DB when click on trash button
  deleteLoan(loanId) {
    return this.http
      .post(`${this.baseurl}/loan/delete`, { loanId })
      .map((res: Response) => res.json());
  }

  // clear all fields loan when click on clear button
  clearLoan(data) {
    return this.http
      .post(`${this.baseurl}/loan/clear`, { data })
      .map((res: Response) => res.json());
  }

  // when calculate button of second part of loan is clicked, then it executes
  updateProfitShares(data) {
    return this.http
      .post(`${this.baseurl}/loan/updateProfitShares`, { data })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/loan.service.ts